
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import TrustSection from './components/TrustSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';
import FooterSection from './components/FooterSection';

export default function HomePage() {
  return (
    <main className="min-h-screen bg-cream">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <ProcessSection />
      <TrustSection />
      <FaqSection />
      <CtaSection />
      <FooterSection />
    </main>
  );
}
